import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import store from "store";
import VirtualList from "rc-virtual-list";
import { Input, Avatar, List, Modal, message } from "antd";
import { SearchOutlined, RightOutlined } from "@ant-design/icons";
import { get_countryInfos } from "api/uaapi/user";
import { get_regCountries, get_faMobileCountries, get_authorizeCountries, get_countryList } from "api/uaapi/account";
import XtSvg from "components/Xt/Svg";
// import { FormattedMessage } from "react-intl";
import { Hooks, XtLocale } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;
import stylesLess from "./index.module.less";
import { aryFilter } from "utils/common/index";
import LocalStorage from "utils/localStorage";
import cookie from "utils/cookie";
import nameSort from "utils/pinyin";
import SvgIcon from "@xt/SvgIcon";
import RightSvg from "assets/icon-svg/withdraw/right.svg";
import iconRight from "assets/images/account/iconRight.png";
import defaultCountryDark from "assets/images/default-country-dark.svg";
import defaultCountryLight from "assets/images/default-country-light.svg";
import defaultCode from "./defaultCode";

import { useRouter } from "next/router";

const formatCountryLabel = (country) => {
  if (!country) return "";
  const displayName = XtLocale.intl.code !== "cn" && country.nameEn ? country.nameEn : country.name;
  const code = country.code || country.countryCode || "";
  const desSuffix = country.des && country.des !== displayName ? ` [${country.des}]` : "";
  if (!code && !displayName) return "";
  if (!code) return displayName || "";
  if (!displayName) return `+${code}`;
  return `+${code} [${displayName}]${desSuffix}`;
};

const getTriggerTitle = (country, showType) => {
  if (showType === "Large") return country.name || "";
  if (showType === "LargeWithCode") return formatCountryLabel(country);
  return "+" + (country.code || country.countryCode || "");
};

export default observer(function CountryList({ selectItem, countryQuery, showType, disabled, style, countryCode }) {
  const intl = useIntl();
  //list height
  const ContainerHeight = 400;
  const ref = React.useRef(null);
  const { locale } = useRouter();
  const { isDark } = store.app;
  const [inputValue, setInputValue] = useState("");
  const [state_loading, setState_loading] = React.useState(false);
  const [state_countryInfo, setState_countryInfo] = React.useState([]);
  const [state_countryList, setState_countryList] = React.useState([]);
  const [state_curCountry, setState_curCountry] = React.useState({
    nationalFlagIcon: "",
    des: "",
    code: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);

  // 默认国家占位图：本地地球图标（深色用白线、浅色用深色线），不再请求 S3 避免 404
  const defaultCountryIcon = isDark ? defaultCountryDark : defaultCountryLight;
  // 仅在有选中国家但无 icon 时用默认图；未选国家时不用默认 URL，避免先请求 404 再闪出正确 icon
  const avatarSrc =
    state_curCountry.nationalFlagIcon ||
    (state_curCountry.name || state_curCountry.id ? defaultCountryIcon : undefined);
  // 显示国家显示框
  const showModal = () => {
    setIsModalVisible(true);
    resetInputField();
    setState_countryInfo(state_countryList);
  };

  // 关闭国家显示框
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // 弹窗打开时锁定背后页面滚动，关闭时恢复
  useEffect(() => {
    if (!isModalVisible) return;
    const scrollY = window.scrollY ?? window.pageYOffset;
    const prevStyle = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    return () => {
      document.body.style.overflow = prevStyle.overflow || "";
      document.body.style.position = prevStyle.position || "";
      document.body.style.top = prevStyle.top || "";
      document.body.style.width = prevStyle.width || "";
      window.scrollTo(0, scrollY);
    };
  }, [isModalVisible]);

  // 输入 Input Field handler
  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  };

  // 清空 Input Field
  const resetInputField = () => {
    setInputValue("");
  };

  // 获取国家列表数据
  const loadCountryList = () => {
    const Query = "?userBehaviorEnum=" + (countryQuery === "ALL" ? "All" : countryQuery);
    if (state_loading) return;
    setState_loading(true);
    get_countryInfos(Query)
      .then((data) => {
        // 接口没有返回国家时，用 defaultCode 作为国家列表
        if (!data?.countryList || !data.countryList.length) {
          const fallbackList = nameSort(defaultCode);
          const curItem = fallbackList[0];
          setState_countryInfo(fallbackList);
          setState_countryList(fallbackList);
          setState_curCountry(curItem);
          selectItem(curItem);
          setLocalStorage(curItem);
          cookie.set("countryId", curItem.id);
          return;
        }
        // 排序(a-z)
        data.countryList = nameSort(data.countryList);
        let getCountry = LocalStorage.get("country") || null;
        //ip判断默认国家
        const defaultCountryId = data.ipCountryId ? data.ipCountryId || null : data.defaultCountryId || null;
        let curItem = {};
        if (countryCode) {
          const item = data.countryList.find((item) => item.code == countryCode);
          if (item) {
            // 向父组件更新当前国家
            selectItem(item);
            // 设置默认国家
            setState_curCountry(item);
          }
          // 更新国家列表
          setState_countryInfo(data.countryList);
          setState_countryList(data.countryList);
          cookie.set("countryId", curItem.id || getCountry.id);
          return;
        }
        if (defaultCountryId) {
          // 有缓存中是否存在国家列表中
          if (getCountry) {
            const localStorageId = getCountry.id;
            const getData = data.countryList.filter((item) => item.id == localStorageId);
            if (getData.length != 0) {
              getCountry = getData[0];
            } else {
              // 如果有ipCountryId
              if (data.ipCountryId) {
                const getData = data.countryList.filter((item) => item.id == data.ipCountryId);
                if (getData.length != 0) {
                  getCountry = getData[0];
                } else {
                  getCountry = data.countryList[0];
                }
              } else {
                getCountry = data.countryList[0];
              }
            }
            LocalStorage.set("country", getCountry);
          } else {
            // 根据ip过滤出当前国家
            const getData = data.countryList.filter((item) => item.id == defaultCountryId);
            curItem = getData[0];
          }
        } else {
          //如果ipCountryId和defaultCountryId都不存在，选择列表第一个
          curItem = data.countryList[0];
        }
        if (getCountry) {
          // 缓存中设置默认国家
          setState_curCountry(getCountry);
          // 向父组件更新当前国家
          selectItem(getCountry);
        } else {
          // 设置默认国家
          setState_curCountry(curItem);
          // 向父组件更新当前国家
          selectItem(curItem);
          // LocalStorage存储
          setLocalStorage(curItem);
        }
        // 更新国家列表
        setState_countryInfo(data.countryList);
        setState_countryList(data.countryList);
        cookie.set("countryId", curItem.id || getCountry.id);
        console.log(data.countryList, "加载ddd");
      })
      .catch((err) => {
        // 接口失败时用 defaultCode 作为国家列表
        const fallbackList = nameSort(defaultCode);
        const cached = LocalStorage.get("country") || null;
        const curItem = cached && fallbackList.some((c) => c.id === cached.id) ? cached : fallbackList[0];
        setState_countryInfo(fallbackList);
        setState_countryList(fallbackList);
        setState_curCountry(curItem);
        selectItem(curItem);
        setLocalStorage(curItem);
        cookie.set("countryId", curItem.id);
        message.error(err?.message || (intl.formatMessage({ id: "common.fetchCountryListFailed" }) || "Failed to load country list, please try again later"));
      })
      .finally(() => {
        setState_loading(false);
      });
  };
  /*
  const loadCountryList = () => {
    if (state_loading) return;
    setState_loading(true);

    const funObj = {
      REG: get_regCountries,
      MOBILE: get_faMobileCountries,
      ALL: get_authorizeCountries,
      SAFETY_MOBILE: get_countryList,
    };

    funObj[countryQuery]()
      .then((data) => {
        const listFormat = nameSort(data);
        const defaultItem = (() => {
          let item;
          const cookieCountryId = cookie.get("countryId");
          if (cookieCountryId) {
            item = listFormat.find((obj) => obj.id == cookieCountryId);
            if (item) return item;
          }
          const localCountry = LocalStorage.get("country");
          if (localCountry && localCountry.id) {
            item = listFormat.find((obj) => obj.id == localCountry.id);
            if (item) return item;
          }

          item = listFormat.find((obj) => !!obj.idDefault);

          return item || listFormat[0];
        })();
        console.log("defaultItem =", defaultItem);

        setState_countryInfo(listFormat);
        setState_countryList(listFormat);
        setState_curCountry(defaultItem);
        selectItem(defaultItem);
      })
      .finally(() => {
        setState_loading(false);
      });
  };
   */

  // 加载接口
  // React.useEffect(() => {
  //   loadCountryList();
  // }, []);

  // state_countryInfo更新时执行
  /* eslint-disable */
  React.useEffect(() => {}, [state_countryInfo]);

  // locale更新国家接口
  React.useEffect(() => {
    loadCountryList();
  }, [locale]);

  useEffect(() => {
    if (countryCode) {
      const item = state_countryList.find((item) => item.code == countryCode);
      if (item) {
        // 向父组件更新当前国家
        selectItem(item);
        // 设置默认国家
        setState_curCountry(item);
      }
    }
  }, [countryCode, state_countryList]);

  // 存储LocalStorage
  const setLocalStorage = (item) => {
    LocalStorage.set("country", item);
  };

  // 选择国家
  const setItem = (item) => {
    // 向父组件更新当前国家
    selectItem(item);
    // 设置默认国家
    setState_curCountry(item);
    handleCancel();
    // 存储LocalStorage
    setLocalStorage(item);
    cookie.set("countryId", item.id);
  };

  // 键盘输入
  const inputKeyUp = (e) => {
    const getVal = e.target.value;
    if (getVal == "") {
      setState_countryInfo(state_countryList);
    } else {
      const result = aryFilter(state_countryList, getVal, {});
      setState_countryInfo(result);
    }
  };

  return (
    <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
      {/* 国家选择 */}
      <List.Item className="country-select" style={style} onClick={!disabled ? showModal : null}>
        <List.Item.Meta
          avatar={<Avatar src={avatarSrc} />}
          title={getTriggerTitle(state_curCountry, showType)}
        />
        <div className={stylesLess.iconRight}>
          {/* <SvgIcon src={RightSvg} /> */}
          <img src={iconRight} alt="iconRight" />
        </div>
      </List.Item>

      {/* 国家列表 */}
      <Modal
        className="country-modal"
        open={isModalVisible}
        style={{ top: "10%" }}
        width={400}
        keyboard={true}
        closable={false}
        bodyStyle={{
          borderRadius: "16px",
          background: "#1f222b",
          padding: "20px",
        }}
        maskClosable={true}
        title={null}
        footer={false}
        onCancel={handleCancel}
      >
        <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
          {/* Title */}
          <div className="title-box">
            <FormattedMessage id="app.selectCountry" className="text-title" />
            <div
              className="icon-close"
              onClick={() => {
                handleCancel();
              }}
            >
              <XtSvg icon={"close"} />
            </div>
          </div>

          {/* Search */}
          <Input
            // allowClear
            ref={ref}
            prefix={<XtSvg icon={"search"} className="site-form-item-icon" />}
            onKeyUp={(e) => inputKeyUp(e)}
            // onkeydown={e => inputKeyUp(e)}
            onPressEnter={(e) => inputKeyUp(e)}
            // onChange={e => inputKeyUp(e)}
            onChange={handleUserInput}
            className="input"
            placeholder="Search"
            bordered={false}
            value={inputValue}
          />

          {/* List */}
          <ul className="country-list">
            {state_countryInfo.length != 0 ? (
              <List>
                <VirtualList
                  data={state_countryInfo}
                  height={ContainerHeight}
                  itemHeight={44}
                  itemKey="id"
                  // onScroll={onScroll}
                >
                  {(item) => (
                    <List.Item key={item.id} onClick={() => setItem(item)}>
                      <List.Item.Meta
                        avatar={<Avatar src={item.nationalFlagIcon} width={24} height={24} />}
                        title={<span className="title">{item.name}</span>}
                      />
                      {countryQuery != "REG" ? <div className="code">+{item.code || item.countryCode || ""}</div> : ""}
                    </List.Item>
                  )}
                </VirtualList>
              </List>
            ) : (
              <li className="none">
                <FormattedMessage id="app.noneText" />
              </li>
            )}
          </ul>
        </div>
      </Modal>
    </div>
  );
});
